import {ImageRequestParams} from "../../models/image/image-request-params";

export class TopScorerDeselectedImageRequestParams extends ImageRequestParams {
  constructor(width: Number, height: Number) {
    super({width, height});

    this._resourceName = `bolao26/Icons/Top_Scorer_Deselected`;
  }
}
